export const selectContacts = state => {
  return state.contacts;
};

export const selectFilter = state => {
  return state.filter.filter;
};